import loadable from '@loadable/component';

import LoadingPage from '../../../components/LoadingPage';

const LoadableReasonCodesPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableReasonCodesPage;
